<div class="map-container">
    <div id="map" class="map" ></div>
  </div>
